export default __webpack_public_path__ + "static/media/ic-exit.dcdd7b39.svg";